module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ja_shikoku-3148a9df58d89c57678750828a157943.jpg";